import Havena1 from "./12x18 (1).webp";
import Havena2 from "./12x18 (2).webp";
import Havena3 from "./12x18 (3).webp";
import Havena4 from "./12x18 (4).webp";
import Havena5 from "./12x18 (5).webp";
import Havena6 from "./12x18 (6).webp";
import Havena7 from "./12x18 (7).webp";
import Havena8 from "./12x18 (8).webp";
import Havena9 from "./12x18 (9).webp";
import Havena10 from "./12x18 (10).webp";
import Havena11 from "./12x18 (11).webp";
import Havena12 from "./12x18 (12).webp";
import Havena13 from "./12x18 (13).webp";
import Havena14 from "./Havena 12 Attic.jpg";
const Havena12images = [
  Havena14,
  Havena1,
  Havena2,
  Havena3,
  Havena4,
  Havena5,
  Havena6,
  Havena7,
  Havena8,
  Havena9,
  Havena10,
  Havena11,
  Havena12,
  Havena13,
];

export default Havena12images;
